import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

import RoutingPaths from "../utils/RoutingPaths";

import OrgDashboardRouter from "./OrgDashboardRouter";
import SectionLoader from "../components/global/loader/SectionLoader";
import PageNotFound from "../pages/org_dashboard/other/PageNotFound";

const Login = lazy(() => import("../pages/auth/Login"));
const SignUp = lazy(() => import("../pages/auth/SignUp"));
const ClientSignUp = lazy(() => import("../pages/auth/ClientSignUp"));

const ForgotPassword = lazy(() =>
  import("../pages/auth/forgot_password/ForgotPassword")
);
const ForgotPasswordValidateToken = lazy(() =>
  import("../pages/auth/forgot_password/ForgotPasswordValidateToken")
);
const ForgotPasswordChange = lazy(() =>
  import("../pages/auth/forgot_password/ForgotPasswordChange")
);
const ProfileVerification = lazy(() =>
  import("../pages/auth/ProfileVerification")
);
const PrivacyPolicy = lazy(() =>
  import("../pages/org_dashboard/other/PrivacyPolicy")
);
const TermsAndConditions = lazy(() =>
  import("../pages/org_dashboard/other/TermsAndConditions")
);
const ApplicationDetails = lazy(() =>
  import("../pages/org_dashboard/other/ApplicationDetails")
);
const DocumentViewVerification = lazy(() =>
  import("../pages/auth/DocumentViewVerification")
);

function Router() {
  return (
    <Suspense fallback={<SectionLoader />}>
      <Routes>
        <Route exact path={RoutingPaths.LOGIN} element={<Login />} />
        <Route exact path={RoutingPaths.SIGN_UP} element={<SignUp />} />
        <Route
          exact
          path={RoutingPaths.CLIENT_SIGN_UP}
          element={<ClientSignUp />}
        />

        <Route exact path={RoutingPaths.FORGOT_PASSWORD}>
          <Route exact index element={<ForgotPassword />} />

          <Route
            exact
            path={RoutingPaths.FORGOT_PASSWORD_VALIDATE_TOKEN + "/:userType"}
            element={<ForgotPasswordValidateToken />}
          />

          <Route
            exact
            path={RoutingPaths.FORGOT_PASSWORD_CHANGE + "/:userType"}
            element={<ForgotPasswordChange />}
          />
        </Route>

        <Route
          exact
          path={RoutingPaths.PROFILE_VERIFY}
          element={<ProfileVerification />}
        />
        <Route
          exact
          path={RoutingPaths.PRIVACY_POLICY}
          element={<PrivacyPolicy />}
        />
        <Route
          exact
          path={RoutingPaths.TERMS_AND_CONDITIONS}
          element={<TermsAndConditions />}
        />
        <Route
          exact
          path={RoutingPaths.APP_DETAILS}
          element={<ApplicationDetails />}
        />
        <Route
          path={`${RoutingPaths.DASHBOARD}/*`}
          element={<OrgDashboardRouter />}
        />

        <Route
          exact
          path={RoutingPaths.SMS_DOC_VIEW + "/:id"}
          element={<DocumentViewVerification />}
        />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
}

export default Router;
